// extracted by mini-css-extract-plugin
module.exports = {"main-card":"LotteryWidgetBlock_main-card__7yz6B","second-bar":"LotteryWidgetBlock_second-bar__pqcq_"};